import React from 'react';
import { faVolumeUp } from "@fortawesome/free-solid-svg-icons"
import useAsyncCallback from "../../../../../hooks/useAsyncCallback"
import IconOrSpinner from "../../../../Utils/IconOrSpinner"
import "./styles.css"
import { GetArquivoLigacaoController } from '../../../../../Controllers/Geral/ContaLigacao/ContaLigacaoControllers';

interface IVerLigacaoProps{
    ID_CONTA_LIGACAO: number
}

export default function VerLigacao(props: IVerLigacaoProps){
    const {
        value: blobLigacao,
        loading,
        execute: CarregarArquivoDeAudioDaLigacao
    }  = useAsyncCallback(async ()=>{
        return GetArquivoLigacaoController(props.ID_CONTA_LIGACAO)
    })
    
    if (blobLigacao){
        return (
            <audio controls className="mw-100 w-100 audio-historico">
                <source src={`data:audio/mpeg;base64,${blobLigacao}`}/>
            </audio>
        )
    }
    else {
        return (
            <button 
                className="btn btn-link-primary font-weight-bold d-flex align-items-center g-2"
                onClick={CarregarArquivoDeAudioDaLigacao}
                disabled={loading}
            >
                Ouvir Ligação
                <IconOrSpinner 
                    icon={faVolumeUp}
                    loading={loading}
                    loadingSize="sm"
                />
            </button>
        )
    }
}